import { jsx as _jsx } from "react/jsx-runtime";
import SharedComponents from "../SharedComponents";
const Video = (props) => {
    let { renderVideo } = SharedComponents.useContext();
    if (typeof renderVideo === "function") {
        return renderVideo(props);
    }
    return (_jsx("video", { src: props.src, autoPlay: props.autoplay, poster: props.poster, controls: props.controls, muted: props.muted, loop: props.loop, style: {
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: props.fit,
        } }));
};
export default Video;
